import Vue from 'vue'

Vue.http.interceptors.push((request, next) => {
  let token = sessionStorage.getItem('token');

  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }

  next((response) => {
  	if (response.headers.has('Authorization')) {
  		sessionStorage.setItem('token', response.headers.get('Authorization').substr('Bearer '.length));
  	}
  });
});



// WEBPACK FOOTER //
// ./src/interceptors/jwt.js